import React from 'react';
import { truncateText } from 'helpers/utilCommon';
import CustomTooltip from "components/atoms/Tooltip";
import { Icon } from 'semantic-ui-react';
import { DragDropContext } from '../../shared-componenets/AtlasDragDrop/DragDropProvider';
import { Droppable } from '../../shared-componenets/AtlasDragDrop/Droppable';
import { Draggable } from '../../shared-componenets/AtlasDragDrop/Draggable';


class Dragdrop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: props.items,
      padding: 8
    };

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ items: nextProps.items })
  }

  // A little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  getItemStyle = (isDragging, draggableStyle) => ({
    // Some basic styles to make the items look a bit nicer
    userSelect: 'none',
    display: isDragging ? 'table' : '',
    // Change background colour if dragging
    background: isDragging ? '#f1f1f1' : '#000',

    // Styles we need to apply on draggables
    ...draggableStyle
  });

  getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : '#f1f1f1',
    padding: this.state.padding,
    border: this.state.border
  });


  onDragEnd(result) {
    // Dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.props.resequenceItems(items);

    this.setState({
      items
    });
  }

  componentDidMount() {

    const targetElements = document.getElementsByClassName('truncatedText');

    for (let i = 0; i < targetElements.length; i++) {
      truncateText(targetElements[i], 2, 40);
    }
  }

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    const { items } = this.state;
    const { openViewModal, allowResequenceing, deleteFAQ, allowDelete } = this.props;

    return (
      allowResequenceing ?
        <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
          <Droppable droppableId="droppable" as="tbody" style={this.getListStyle()}>
                {items.map((item, index) => (
                  <Draggable key={item.ClassificationTypeId} draggableId={String(item.ClassificationTypeId)} index={index}
                    as="tr" style={this.getItemStyle()}>
                        <td className="seqNo">
                          <i aria-hidden="true" class="equal icon"></i>&nbsp;
                          <span dangerouslySetInnerHTML={{ __html: item.ClassificationSequence }}>
                          </span>
                        </td>
                        <td>
                          <a onClick={e => openViewModal(item)} className="truncatedText" dangerouslySetInnerHTML={{ __html: item.Name }}></a>
                        </td>
                        <td className="description">
                          <CustomTooltip position='bottom left' className="leftAlignTolltip"
                            icon={<div class="twoLiner ellip" style={{ '-webkit-box-orient': 'vertical' }}><span dangerouslySetInnerHTML={{ __html: item.Description }}></span></div>}
                            content={item.Description} />
                        </td>
                        <td>
                          <div dangerouslySetInnerHTML={{ __html: item.IsApplicableToAllCommittees ? 'Yes' : 'Specific to a Committee' }}>
                          </div>
                        </td>
                  </Draggable>
                ))}
          </Droppable>
        </DragDropContext> :

        <tbody>
          {items.map((item, index) => (
            <tr >
              <td className="seqNo">
                <i aria-hidden="true" class="equal icon"></i>&nbsp;
                <span dangerouslySetInnerHTML={{ __html: item.ClassificationSequence }}>
                </span>
              </td>
              <td>
                <a onClick={e => openViewModal(item)} className="truncatedText" dangerouslySetInnerHTML={{ __html: item.Name }}></a>
              </td>
              <td className="description">
                <div class="truncatedText" dangerouslySetInnerHTML={{ __html: item.Description }}>
                </div>
              </td>
              <td>
                <div dangerouslySetInnerHTML={{ __html: item.IsApplicableToAllCommittees ? 'Yes' : 'Specific to a Committee' }}>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
    );
  }
}
export default Dragdrop
